import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";

const empty = { name: "", tipo: "PTI", ordine: "", provincia: "Vicenza", phone: "", email: "", specializzazione: "" };

export default function TechniciansAdmin() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/technicians").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    try {
      if (editing.id) await api.put(`/technicians/${editing.id}`, editing);
      else await api.post("/technicians", editing);
      setEditing(null); load(); toast.success("Salvato");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const del = async (id) => { if (!window.confirm("Eliminare?")) return; await api.delete(`/technicians/${id}`); load(); };

  return (
    <div data-testid="tech-admin">
      <div className="flex justify-between items-end mb-8">
        <div><div className="label-uppercase">Anagrafica</div><h1 className="font-serif text-4xl mt-2">PTI e Aziende specializzate</h1></div>
        <button data-testid="new-tech-btn" onClick={() => setEditing({ ...empty })} className="btn-primary">Nuovo professionista</button>
      </div>
      <table className="admin-table w-full bg-white border border-[#E6E4E0]">
        <thead><tr><th>Nome</th><th>Tipo</th><th>Ordine / P.IVA</th><th>Provincia</th><th>Specializzazione</th><th>Contatti</th><th></th></tr></thead>
        <tbody>
          {items.map((t) => (
            <tr key={t.id}>
              <td className="font-medium">{t.name}</td>
              <td><span className="badge-stamp" style={{color: t.tipo === "PTI" ? "#7D2E3F" : "#5C5657"}}>{t.tipo || "PTI"}</span></td>
              <td>{t.ordine}</td>
              <td>{t.provincia}</td>
              <td className="text-xs">{t.specializzazione || "—"}</td>
              <td className="text-xs">{t.phone} {t.email && `· ${t.email}`}</td>
              <td className="text-right space-x-3">
                <button onClick={() => setEditing(t)} className="text-xs label-uppercase text-[#7D2E3F]">Modifica</button>
                <button onClick={() => del(t.id)} className="text-xs label-uppercase text-[#B3261E]">Elimina</button>
              </td>
            </tr>
          ))}
          {items.length === 0 && <tr><td colSpan="7" className="text-center py-8 text-[#5C5657]">Nessun professionista</td></tr>}
        </tbody>
      </table>
      {editing && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={() => setEditing(null)}>
          <div onClick={(e) => e.stopPropagation()} className="bg-white border border-[#E6E4E0] max-w-2xl w-full p-8">
            <h2 className="font-serif text-2xl mb-6">{editing.id ? "Modifica" : "Nuovo"} professionista</h2>
            <div className="grid grid-cols-2 gap-4">
              <div className="col-span-2"><label className="label-uppercase">Tipo *</label>
                <select value={editing.tipo || "PTI"} onChange={(e) => setEditing({ ...editing, tipo: e.target.value })} className="admin-input" data-testid="tech-tipo">
                  <option value="PTI">PTI — Professionista Tecnico Incaricato</option>
                  <option value="Azienda specializzata">Azienda specializzata (impianti)</option>
                </select></div>
              <div className="col-span-2"><label className="label-uppercase">Nome *</label><input data-testid="tech-name" value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} className="admin-input" /></div>
              <div className="col-span-2"><label className="label-uppercase">Ordine/Albo o P.IVA *</label><input value={editing.ordine} onChange={(e) => setEditing({ ...editing, ordine: e.target.value })} className="admin-input" /></div>
              <div><label className="label-uppercase">Provincia</label><input value={editing.provincia} onChange={(e) => setEditing({ ...editing, provincia: e.target.value })} className="admin-input" /></div>
              <div><label className="label-uppercase">Specializzazione</label><input value={editing.specializzazione || ""} onChange={(e) => setEditing({ ...editing, specializzazione: e.target.value })} className="admin-input" /></div>
              <div><label className="label-uppercase">Telefono</label><input value={editing.phone || ""} onChange={(e) => setEditing({ ...editing, phone: e.target.value })} className="admin-input" /></div>
              <div><label className="label-uppercase">Email</label><input value={editing.email || ""} onChange={(e) => setEditing({ ...editing, email: e.target.value })} className="admin-input" /></div>
            </div>
            <div className="flex justify-end gap-3 mt-8">
              <button onClick={() => setEditing(null)} className="btn-secondary">Annulla</button>
              <button data-testid="tech-save" onClick={save} className="btn-primary">Salva</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
